module.exports = __webpack_public_path__ + "img/section2.4c8fc545.svg";